import { render, staticRenderFns } from "./addChangeClassification.vue?vue&type=template&id=65d5b14e&scoped=true&"
import script from "./addChangeClassification.vue?vue&type=script&lang=js&"
export * from "./addChangeClassification.vue?vue&type=script&lang=js&"
import style0 from "./addChangeClassification.vue?vue&type=style&index=0&id=65d5b14e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d5b14e",
  null
  
)

export default component.exports